import { Capacitor } from '@capacitor/core';

export const getRootURL = () => {
  if (Capacitor.isNativePlatform()) {
    return 'https://app.sworkit.com';
    // can't redirect to capacitor:// - must use deep link redirects
  } else {
    console.debug('getRootUrl', `${location.protocol}//${location.host}`);
    return `${location.protocol}//${location.host}`;
  }
};

export const getIsProd = () => {
  if (Capacitor.isNativePlatform()) {
    return true;
    // can't redirect to capacitor:// - must use deep link redirects
  } else {
    return (
      location.host === 'app.sworkit.com' ||
      location.host === 'beta.sworkit.com'
    );
  }
};

export const cleverRedirect: string = encodeURI(`${getRootURL()}/clever`);
export const virginPulseRedirect: string = encodeURI(`${getRootURL()}/auth/vp`);
export const personifyRedirect: string = encodeURI(
  `${getRootURL()}/auth/personify`,
);

export const soleraRedirect: string = encodeURI(`${getRootURL()}/auth/solera`);
export const fitbitRedirect: string = encodeURI(`${getRootURL()}/auth/fitbit`);
export const oAuthExternalUrlMap = {
  clever: `https://clever.com/oauth/authorize?response_type=code&redirect_uri=${cleverRedirect}&client_id=d18f4eb5d2628f7267d5`,
  'virgin-pulse': `https://${
    getIsProd() ? 'iam.virginpulse.com' : 'iam.stage2.virginpulse.com'
  }/auth/realms/virginpulse/protocol/openid-connect/auth?response_type=code&redirect_uri=${virginPulseRedirect}&client_id=pif-sworkit&scope=events%20openid`,
  personify: `https://${
    getIsProd()
      ? 'login.personifyhealth.com'
      : 'login.pilot.personifyhealth.com'
  }/auth/realms/platform/protocol/openid-connect/auth?response_type=code&redirect_uri=${personifyRedirect}&client_id=pif-sworkit&scope=openid`,
};

export const loginWithExternalUrl = (
  keyString: AuthState['oAuthInitiated'],
) => {
  const url = oAuthExternalUrlMap[keyString];
  return url ? url : '/';
};
